module.exports = __webpack_public_path__ + "media/images/ui__arrowUpInactive--dark-8512c58d5230ef7fcf06098768f2eca2.png";